import React from "react";
import { FaLinkedinIn, FaGithub, FaWhatsapp, FaJava } from "react-icons/fa";
import { SiSelenium, SiCypress, SiCucumber } from "react-icons/si";

const Media = () => {
  return (
    <div className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">
      <div>
        <h2 className="text-base uppercase font-titleFont mb-4">
          Find me in
        </h2>
        <div className="flex gap-4">
          <a
            className="bannerIcon"
            href="https://www.linkedin.com/in/cesar-agudelo/"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedinIn />
          </a>

          <a
            className="bannerIcon"
            href="https://github.com/cesaragudeloh"
            target="_blank"
            rel="noreferrer"
            aria-label="GitHub"
          >
            <FaGithub />
          </a>

          <a
            className="bannerIcon"
            href="https://wa.me/573127555467"
            target="_blank"
            rel="noreferrer"
            aria-label="WhatsApp"
          >
            <FaWhatsapp />
          </a>
        </div>
      </div>

      <div>
        <h2 className="text-base uppercase font-titleFont mb-4">
          BEST SKILL ON
        </h2>
        <div className="flex gap-4">
          <span className="bannerIcon">
            <SiSelenium />
          </span>
          <span className="bannerIcon">
            <SiCypress />
          </span>
          <span className="bannerIcon">
            <SiCucumber />
          </span>
          <span className="bannerIcon">
            <FaJava />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Media;